<template>
  <div
    class="caseInfo"
    v-if="formData.baseInfo"
  >
    <div class="orderInfo">
      <div>订单状态：<span class="status">{{ formData.baseInfo.orderStatusName }}</span></div>
      <div>结算金额：<span class="num">{{ formData.orderCostInfo.channelSettleAmount }}元</span></div>
    </div>
    <div class="center">
      <div class="cell">
        <span class="title">任务编号</span>
        <div class="item">{{ formData.baseInfo.orderNo }} <span
          class="copy"
          @click="copy($event,'orderNo')"
        >复制</span></div>
      </div>
      <div class="cell">
        <span class="title">保司单号</span>
        <div class="item">{{ formData.baseInfo.caseNo }} <span
          class="copy"
          @click="copy($event,'caseNo')"
        >复制</span></div>
      </div>
      <div class="cell">
        <span class="title">保单号码</span>
        <div class="item">{{ formData.baseInfo.insuranceNo }} <span
          class="copy"
          @click="copy($event,'insuranceNo')"
        >复制</span></div>
      </div>
      <div class="cell">
        <span class="title">下单时间</span>
        <span>{{ formData.baseInfo.createTime }}</span>
      </div>
      <div class="cell">
        <span class="title">任务类型</span>
        <span>{{ formData.baseInfo.categoryParentName }}/{{ formData.baseInfo.categoryCodeName }}/{{ formData.baseInfo.productSkuName }}</span>
      </div>
      <div class="cell">
        <span class="title">车牌号码</span>
        <span>{{ formData.carInfo.carNo }}</span>
      </div>
      <div class="cell">
        <span class="title">车架号码</span>
        <span>{{ formData.carInfo.vinNo }}</span>
      </div>
      <div class="cell">
        <span class="title">联系人员</span>
        <span>{{ formData.customerInfo.contactName }}</span>
      </div>
      <div class="cell">
        <span class="title">联系电话</span>
        <span>{{ formData.customerInfo.contactPhone }}</span>
      </div>
      <div class="cell">
        <span class="title">预约时间</span>
        <span>{{ formData.baseInfo.appointmentTime }}</span>
      </div>
      <div class="cell">
        <span class="title">备注</span>
        <span>{{ formData.baseInfo.dpsOrderRemark }}</span>
      </div>
      <div class="cell">
        <span class="title">服务地址</span>
        <span class="long-text">{{ formData.customerInfo.contactAddress }}</span>
      </div>
      <div class="cell">
        <span class="title">终点地址</span>
        <span class="long-text">{{ formData.customerInfo.destination }}</span>
      </div>
    </div>
    <div class="center">
      <div class="cell">
        <span class="title">服务人员</span>
        <div class="item">{{ formData.serviceInfo.workerName }}</div>
      </div>
      <div class="cell">
        <span class="title">联系电话</span>
        <div class="item">{{ formData.serviceInfo.workerPhone }} <span
          class="copy"
          @click="clickPhone"
          v-if="formData.serviceInfo.workerPhone"
        >拨打电话</span></div>
      </div>
      <a
        :href="`tel:${formData.serviceInfo.workerPhone}`"
        ref="telPhone"
        style="display:none;"
      />
    </div>
  </div>
</template>
<script>
import { handleClipboard } from '@/common/clipboard';
export default {
  props: {
    formData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    copy(e, type) {
      if (type === 'orderNo') {
        handleClipboard(this.formData.baseInfo.orderNo, e);
      } else if (type === 'caseNo') {
        handleClipboard(this.formData.baseInfo.caseNo, e);
      } else if (type === 'insuranceNo') {
        handleClipboard(this.formData.baseInfo.insuranceNo, e);
      }
    },
    clickPhone() {
      this.$dialog.confirm({
        title: '提示',
        message:
          `确定拨打电话:${this.formData.serviceInfo.workerPhone}`
      })
        .then(() => {
          // on confirm
          this.$refs.telPhone.click();
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.caseInfo{
  height: 100vh;

  background: #F2F3F5;
  .orderInfo{
    display: flex;
    justify-content: space-between;

    box-sizing: border-box;
    width: 94vw;
    margin: 0.3rem auto;
    padding: 0.4rem 0.5rem;

    color: #646464;
    border-radius: 0.2rem;
    background: #fff;

    font-size: 0.3rem;
    .status{
      color: #383838;
    }
    .num{
      color: #F32222;
    }
  }
  .center{
    box-sizing: border-box;
    width: 94vw;
    margin: 0.3rem auto;
    padding: 0.3rem;

    border-radius: 0.2rem;
    background: #fff;

    font-size: 0.3rem;
    .cell{
      display: flex;

      margin-bottom: 0.3rem;

      color: #383838;

      line-height: 1.5;
      .title{
        width: 1.6rem;

        color: #999;
      }
      .long-text{
        width: calc(100% - 1.6rem);
      }
      .item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .copy{
          margin-left: 0.2rem;
          padding: 0.06rem;

          color: #3399FF;
          border: 1px solid rgba(137,196,255,1);
          border-radius: 0.08rem;
          background: #EAF4FF;

          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>
